import moment from 'moment'

export const DATE_FORMAT_CH = 'DD.MM.YYYY'
export const DATE_FORMAT_CH_COURT = 'DD.MM.YY'

export default class ParserDate {
  static getDateFromCh(dateChaine: string): Date {
    if (!dateChaine) {
      return null
    }
    const date = moment(dateChaine, DATE_FORMAT_CH)

    if (!date.isValid()) {
      return null
    }
    return date.toDate()
  }

  static getFormattedDateFromDate(date: Date) {
    if (!date) {
      return null
    }
    return moment(date).format(DATE_FORMAT_CH)
  }

  static getFormattedDateCourteFromDate(date: Date) {
    if (!date) {
      return null
    }
    return moment(date, DATE_FORMAT_CH).format(DATE_FORMAT_CH_COURT)
  }
}
